import React from 'react'
import { Table, TableBody, TableCell, TableRow, Skeleton } from '@mui/material'

export const AccountSummary = (props) => {
  const { data = {}, isLoading, columns = [] } = props

  return (
    <Table
      sx={{
        display: 'inline-block',
        border: 'none',
        '& .MuiTableCell-root': { borderBottom: 'none' },
        marginBottom: 8,
      }}
    >
      <TableBody>
        {columns.map((info, idx) => (
          <TableRow key={idx}>
            <TableCell>{info.label}</TableCell>
            <TableCell>
              {isLoading ? <Skeleton width={120} /> : info.view ? info.view(data) : data?.[info.id]}
            </TableCell>
          </TableRow>
        ))}
      </TableBody>
    </Table>
  )
}
